import { route as cartRoute } from "@faire/web-api/routes/cart";
import cartPath from "@faire/web-api/routes/cart";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNextPrefetchContext } from "@faire/retailer/app/_lib/routing/NextPrefetchContext";
import { usePrefetchCart } from "@faire/retailer/features/Cart/useCart";
import { getSettingCartRenderAndPrefetchOptimizations } from "@faire/retailer/settings/getSettingCartRenderAndPrefetchOptimizations";

import { usePrefetchCartSummary } from "./useCartSummary";

export const useCartPrefetch = () => {
  const history = useHistory();
  const { prefetchActiveCart } = usePrefetchCart();
  const { prefetchActiveCartSummary } = usePrefetchCartSummary();
  const nextPrefetch = useNextPrefetchContext();

  return useCallback(
    (href: string = cartRoute) => {
      if (
        getSettingCartRenderAndPrefetchOptimizations() &&
        history.location.pathname !== cartPath()
      ) {
        prefetchActiveCart();
        prefetchActiveCartSummary();
        nextPrefetch(href);
      }
    },
    [
      history.location.pathname,
      nextPrefetch,
      prefetchActiveCart,
      prefetchActiveCartSummary,
    ]
  );
};
